"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9855],{

/***/ 23208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BlogComponent": function() { return /* binding */ BlogComponent; },
/* harmony export */   "BlogHeroPage": function() { return /* binding */ BlogHeroPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_isMobileDevice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26910);
/* harmony import */ var _Carousel_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58619);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_WIdgetPropertiesBasic_components_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46976);
/* harmony import */ var src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91850);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _CardFrameCollection_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90331);
/* harmony import */ var _components_DesignSystem_AtomicDesignsUtilities_ContentAnimationStyles_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(89429);
/* harmony import */ var _components_DesignSystem_AtomicDesignsUtilities_ContentAnimationStyles_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_components_DesignSystem_AtomicDesignsUtilities_ContentAnimationStyles_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _MultiColumn_MultiColumnHelper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94078);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var src_utils_routes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(44541);
/* harmony import */ var src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26706);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(67294);















var REMOVE_GLOBAL_STYLE = [
    "circle",
    "arch",
    "blob"
];
var BlogComponent = function(props) {
    var handleClick = function handleClick(index) {
        var ref;
        router.push((0,src_utils_routes__WEBPACK_IMPORTED_MODULE_9__.getRoute)("/blog/".concat(columnData === null || columnData === void 0 ? void 0 : columnData.slug), store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    var renderImage = function renderImage(data, index) {
        var ref, ref1;
        var url = data === null || data === void 0 ? void 0 : (ref = data.imageDetail) === null || ref === void 0 ? void 0 : ref.url;
        var shapeStyleCalculated = (0,_CardFrameCollection_utils__WEBPACK_IMPORTED_MODULE_6__/* .getShapeStyles */ .cw)(imageShape, oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.width);
        var shapeStyle = shapeStyleCalculated[0];
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_5___default()("tw-relative tw-flex-shrink-0 tw-cursor-pointer tw-overflow-hidden ".concat(textPosition === "below" && !isMobileLeftAlignImage ? " tw-mb-[20px] " : "", " \n          ").concat(!(REMOVE_GLOBAL_STYLE === null || REMOVE_GLOBAL_STYLE === void 0 ? void 0 : REMOVE_GLOBAL_STYLE.includes(imageShape)) ? appearance === "card" && isFullWidthImage && !isMobileLeftAlignImage ? "removeGlobalOverride imgWrapperGlobalStyle globalImgStyleConsumer addTopLeftGlobalRadius addTopRightGlobalRadius" : appearance === "card" && isFullWidthImage && isMobileLeftAlignImage ? "removeGlobalOverride imgWrapperGlobalStyle globalImgStyleConsumer addTopLeftGlobalRadius addBottomLeftGlobalRadius" : "imgWrapperGlobalStyle" : ""), !isMobileLeftAlignImage ? shapeStyle.className : ""),
            style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                width: !isMobileLeftAlignImage ? "".concat((oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.width) - (appearance === "card" && !isFullWidthImage ? 30 : 2), "px") : "42%",
                height: !isMobileLeftAlignImage ? "".concat((oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.height) - (appearance === "card" && !isFullWidthImage ? 30 : 0), "px") : (buttonConfig === null || buttonConfig === void 0 ? void 0 : (ref1 = buttonConfig[0]) === null || ref1 === void 0 ? void 0 : ref1.isShow) ? appearance === "card" ? "203px" : "175px" : "144px"
            }, !isMobileLeftAlignImage ? shapeStyle.style || {} : {}), {
                justifyContent: textAlignment
            }),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: url || "/assets/images/richTextWithImage.png",
                    className: classnames__WEBPACK_IMPORTED_MODULE_5___default()("tw-absolute tw-h-[100%] tw-w-[100%] tw-object-cover tw-transition-all tw-duration-500", !isMobileLeftAlignImage ? shapeStyle.className : "", !isMobile ? (_components_DesignSystem_AtomicDesignsUtilities_ContentAnimationStyles_module_scss__WEBPACK_IMPORTED_MODULE_14___default())[(0,_CardFrameCollection_utils__WEBPACK_IMPORTED_MODULE_6__/* .getCurrentClass */ .WR)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.hoverType)] : "", appearance === "card" && isFullWidthImage && !isMobileLeftAlignImage ? "removeGlobalOverride imgWrapperGlobalStyle globalImgStyleConsumer addTopLeftGlobalRadius addTopRightGlobalRadius" : appearance === "card" && isFullWidthImage && isMobileLeftAlignImage ? "removeGlobalOverride imgWrapperGlobalStyle globalImgStyleConsumer addTopLeftGlobalRadius addBottomLeftGlobalRadius" : "")
                }),
                textPosition !== "below" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        pointerEvents: "none",
                        background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.7) 100%)",
                        transition: "transform 0.5s ease"
                    },
                    className: !isMobile ? (_components_DesignSystem_AtomicDesignsUtilities_ContentAnimationStyles_module_scss__WEBPACK_IMPORTED_MODULE_14___default())[(0,_CardFrameCollection_utils__WEBPACK_IMPORTED_MODULE_6__/* .getCurrentClass */ .WR)(cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.hoverType)] : ""
                }) : null
            ]
        });
    };
    var renderIconAndImage = function renderIconAndImage(columnData, index) {
        return isShow && renderImage(columnData, index);
    };
    var renderCustomHtml = function renderCustomHtml(content) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: content
        });
    };
    var renderTitleAndDescription = function renderTitleAndDescription(columnData) {
        var title = columnData.title, description = columnData.description, date = columnData.date;
        var titleStyle = (0,_MultiColumn_MultiColumnHelper__WEBPACK_IMPORTED_MODULE_7__/* .getTitleStyles */ .ij)(cardFrameConfig, isMobile);
        var descriptionStyle = (0,_MultiColumn_MultiColumnHelper__WEBPACK_IMPORTED_MODULE_7__/* .getDescriptionStyle */ .TV)(cardFrameConfig, isMobile);
        var dateStyle = (0,_MultiColumn_MultiColumnHelper__WEBPACK_IMPORTED_MODULE_7__/* .getDateStyle */ .eK)(cardFrameConfig, isMobile);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-flex tw-flex-col ".concat(isMobile ? "tw-gap-[6px]" : "tw-gap-[6px]"),
            children: [
                showDate && datePosition === "top" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                        color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.dateColor
                    }, dateStyle === null || dateStyle === void 0 ? void 0 : dateStyle.style), {
                        textAlign: textAlignment
                    }),
                    children: renderCustomHtml(date)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "tw-line-clamp-2 !tw-leading-[1.4]",
                    style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                        color: (cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.titleColor) || ""
                    }, titleStyle === null || titleStyle === void 0 ? void 0 : titleStyle.style), {
                        textAlign: textAlignment
                    }),
                    children: renderCustomHtml(title)
                }),
                showDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                        color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.descriptionColor
                    }, descriptionStyle === null || descriptionStyle === void 0 ? void 0 : descriptionStyle.style), {
                        textAlign: textAlignment
                    }),
                    className: "tw-line-clamp-2 !tw-leading-[1.4]",
                    children: renderCustomHtml(description)
                }),
                showDate && datePosition === "bottom" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                        color: cardFrameConfig === null || cardFrameConfig === void 0 ? void 0 : cardFrameConfig.dateColor
                    }, dateStyle === null || dateStyle === void 0 ? void 0 : dateStyle.style), {
                        textAlign: textAlignment
                    }),
                    children: renderCustomHtml(date)
                })
            ]
        });
    };
    var renderButton = function renderButton(columnData, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "tw-flex",
            children: buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.map(function(buttonData, btnIndex) {
                var buttonVariant = (0,_Carousel_utils__WEBPACK_IMPORTED_MODULE_2__/* .getButtonVariantsData */ .Tk)(buttonData, false);
                var selectedButtonType = buttonVariant[buttonData.type];
                return buttonData.isShow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_WIdgetPropertiesBasic_components_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    size: src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_4__/* .BUTTON_SIZE_TYPE.LARGE */ .n6.LARGE,
                    btnType: buttonData.type,
                    buttonData: buttonData,
                    selectedButtonData: selectedButtonType,
                    variant: selectedButtonType.variant,
                    onClick: function() {
                        return handleClick(index);
                    },
                    className: "!tw-py-[12px] tw-text-[14px]  ".concat(buttonData.type !== src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_4__/* .BUTTON_TYPE.TEXTUAL */ .JB.TEXTUAL ? "!tw-px-[24px]" : isMobile && isMobileLeftAlignImage ? " !tw-py-[0]" : " !tw-pt-[0px]", " \n              ").concat(buttonData.type === src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_4__/* .BUTTON_TYPE.TEXTUAL */ .JB.TEXTUAL ? textAlignment === "left" ? "!tw-justify-start" : "!tw-justify-center" : "", "\n              ").concat(buttonData.type !== src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_4__/* .BUTTON_TYPE.TEXTUAL */ .JB.TEXTUAL ? "tw-w-auto !tw-min-w-[100px] !tw-max-w-[250px]" : "", "\n              "),
                    children: buttonData === null || buttonData === void 0 ? void 0 : buttonData.text
                }, btnIndex) : null;
            })
        });
    };
    var ref, ref1;
    var listPresentationConfig = props.listPresentationConfig, cardFrameConfig = props.cardFrameConfig, oneGridCellGeometry = props.oneGridCellGeometry, columnData = props.columnData, index = props.index;
    var store = (0,src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_10__/* .useSSRSelector */ .kF)(function(state) {
        return {
            store: state.storeReducer.store
        };
    }).store;
    var isMobile = (0,src_components_WidgetMaker_WidgetDnD_isMobileDevice__WEBPACK_IMPORTED_MODULE_1__/* .isMobileDevice */ .s)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var headingRef = (0,react__WEBPACK_IMPORTED_MODULE_11__.useRef)(null);
    var showDate = cardFrameConfig.showDate, showDescription = cardFrameConfig.showDescription, buttonConfig = cardFrameConfig.buttonConfig, textAlignment = cardFrameConfig.textAlignment, imageShape = cardFrameConfig.imageShape, isShow = cardFrameConfig.isShow, textPosition = cardFrameConfig.textPosition, datePosition = cardFrameConfig.datePosition;
    var appearance = listPresentationConfig.appearance, borderColor = listPresentationConfig.borderColor, backgroundColor = listPresentationConfig.backgroundColor, mobileImagePosition = listPresentationConfig.mobileImagePosition, imageWidth = listPresentationConfig.imageWidth;
    var isMobileLeftAlignImage = isMobile && mobileImagePosition === "left";
    var isFullWidthImage = imageWidth === "fullWidth";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        onClick: function() {
            return handleClick(index);
        },
        className: "tw-flex tw-w-[100%] tw-cursor-pointer",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, appearance === "card" ? {
                border: "1px solid ".concat(borderColor),
                background: backgroundColor,
                padding: !isFullWidthImage ? isMobile ? "14px" : "14px" : ""
            } : {}), {
                width: oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.width,
                display: isMobileLeftAlignImage ? "flex" : ""
            }),
            className: "tw-relative tw-flex-col\n          ".concat(appearance === "card" ? "imgWrapperGlobalStyle" : "", "\n          ").concat(isMobile && mobileImagePosition === "left" ? "!tw-flex-row ".concat(appearance === "card" && isFullWidthImage ? "tw-gap-[8px]" : "tw-gap-[20px]") : "", "\n          "),
            children: [
                renderIconAndImage(columnData, index),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    ref: headingRef,
                    style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                        top: (oneGridCellGeometry === null || oneGridCellGeometry === void 0 ? void 0 : oneGridCellGeometry.height) - (((ref = headingRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) + 20 + (appearance === "card" && textPosition !== "below" ? 20 : 0))
                    }, appearance === "card" && isFullWidthImage ? {
                        padding: isMobile ? "0 14px 14px 14px" : "0 14px 14px 14px"
                    } : {}),
                    className: "tw-flex tw-flex-col tw-gap-[20px] ".concat(isMobileLeftAlignImage ? "tw-h-[100%] tw-w-[58%] tw-justify-center" : "", "  ").concat(textPosition !== "below" && !isMobileLeftAlignImage ? "tw-absolute tw-px-[16px] tw-pt-[20px]" : "", "\n           ").concat(isMobileLeftAlignImage && isMobile && appearance === "card" ? " !tw-pt-[14px]" : "", "\n          "),
                    children: [
                        renderTitleAndDescription(columnData),
                        (buttonConfig === null || buttonConfig === void 0 ? void 0 : (ref1 = buttonConfig[0]) === null || ref1 === void 0 ? void 0 : ref1.isShow) && renderButton(columnData, index)
                    ]
                })
            ]
        })
    });
};
function BlogHeroPage(props) {
    var handleClick = function handleClick(index) {
        var ref;
        router.push((0,src_utils_routes__WEBPACK_IMPORTED_MODULE_9__.getRoute)("/blog/".concat(columnData === null || columnData === void 0 ? void 0 : columnData.slug), store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    var renderImage = function renderImage(data) {
        var ref;
        var url = data === null || data === void 0 ? void 0 : (ref = data.imageDetail) === null || ref === void 0 ? void 0 : ref.url;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            onClick: function() {
                return handleClick(index);
            },
            className: classnames__WEBPACK_IMPORTED_MODULE_5___default()("tw-relative tw-flex-shrink-0 tw-cursor-pointer tw-overflow-hidden"),
            style: {
                width: "100%",
                height: "360px"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: url || "/assets/images/richTextWithImage.png",
                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()("tw-absolute tw-h-[100%] tw-w-[100%] tw-object-cover tw-transition-all tw-duration-500")
            })
        });
    };
    var renderCustomHtml = function renderCustomHtml(content) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: content
        });
    };
    var renderTitleAndDescription = function renderTitleAndDescription(columnData) {
        var title = columnData.title, description = columnData.description, date = columnData.date;
        var titleStyle = (0,_MultiColumn_MultiColumnHelper__WEBPACK_IMPORTED_MODULE_7__/* .getTitleStyles */ .ij)(cardFrameConfig, isMobile);
        var descriptionStyle = (0,_MultiColumn_MultiColumnHelper__WEBPACK_IMPORTED_MODULE_7__/* .getDescriptionStyle */ .TV)(cardFrameConfig, isMobile);
        var dateStyle = (0,_MultiColumn_MultiColumnHelper__WEBPACK_IMPORTED_MODULE_7__/* .getDateStyle */ .eK)(cardFrameConfig, isMobile);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-flex tw-flex-col ".concat(isMobile ? "tw-gap-[6px]" : "tw-gap-[6px]"),
            children: [
                showDate && datePosition === "top" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                        color: "#555D70"
                    }, dateStyle === null || dateStyle === void 0 ? void 0 : dateStyle.style), {
                        textAlign: textAlignment
                    }),
                    children: renderCustomHtml(date)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "tw-line-clamp-2 !tw-text-[32px] !tw-leading-[1.4]",
                    style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                        color: "#111C36"
                    }, titleStyle === null || titleStyle === void 0 ? void 0 : titleStyle.style), {
                        textAlign: textAlignment
                    }),
                    children: renderCustomHtml(title)
                }),
                showDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                        color: "#555D70"
                    }, descriptionStyle === null || descriptionStyle === void 0 ? void 0 : descriptionStyle.style), {
                        textAlign: textAlignment
                    }),
                    className: "".concat(textPosition === "below" ? "tw-line-clamp-3" : "tw-line-clamp-2", " !tw-leading-[1.4]"),
                    children: renderCustomHtml(description)
                }),
                showDate && datePosition === "bottom" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
                        color: "#555D70"
                    }, dateStyle === null || dateStyle === void 0 ? void 0 : dateStyle.style), {
                        textAlign: textAlignment
                    }),
                    children: renderCustomHtml(date)
                })
            ]
        });
    };
    var renderButton = function renderButton(columnData, index) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "tw-flex ".concat(appearance !== "card" ? "tw-mb-[20px]" : ""),
            children: buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.map(function(buttonData, btnIndex) {
                var buttonVariant = (0,_Carousel_utils__WEBPACK_IMPORTED_MODULE_2__/* .getButtonVariantsData */ .Tk)(buttonData, false);
                var selectedButtonType = buttonVariant[buttonData.type];
                return buttonData.isShow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_WIdgetPropertiesBasic_components_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    size: src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_4__/* .BUTTON_SIZE_TYPE.LARGE */ .n6.LARGE,
                    btnType: buttonData.type,
                    buttonData: buttonData,
                    selectedButtonData: selectedButtonType,
                    variant: selectedButtonType.variant,
                    onClick: function() {
                        return handleClick(index);
                    },
                    className: "!tw-py-[12px] tw-text-[14px]\n              ".concat(buttonData.type === src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_4__/* .BUTTON_TYPE.TEXTUAL */ .JB.TEXTUAL ? textAlignment === "center" ? "!tw-justify-center" : "!tw-justify-start" : "", "\n              ").concat(buttonData.type !== src_components_WidgetMaker_utils_buttonConstant__WEBPACK_IMPORTED_MODULE_4__/* .BUTTON_TYPE.TEXTUAL */ .JB.TEXTUAL ? " !tw-min-w-[100px] !tw-max-w-[150px]" : "", "\n              "),
                    children: buttonData === null || buttonData === void 0 ? void 0 : buttonData.text
                }, btnIndex) : null;
            })
        });
    };
    var ref;
    var cardFrameConfig = props.cardFrameConfig, blogData = props.blogData, index = props.index, listPresentationConfig = props.listPresentationConfig;
    var isMobile = (0,src_components_WidgetMaker_WidgetDnD_isMobileDevice__WEBPACK_IMPORTED_MODULE_1__/* .isMobileDevice */ .s)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
    var store = (0,src_redux_ssrStore__WEBPACK_IMPORTED_MODULE_10__/* .useSSRSelector */ .kF)(function(state) {
        return {
            store: state.storeReducer.store
        };
    }).store;
    var columnData = (blogData === null || blogData === void 0 ? void 0 : blogData[0]) || {};
    var appearance = listPresentationConfig.appearance;
    var showDate = cardFrameConfig.showDate, showDescription = cardFrameConfig.showDescription, buttonConfig = cardFrameConfig.buttonConfig, textAlignment = cardFrameConfig.textAlignment, isShow = cardFrameConfig.isShow, textPosition = cardFrameConfig.textPosition, datePosition = cardFrameConfig.datePosition;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "tw-mb-[60px] tw-flex tw-w-[100%] tw-items-center tw-gap-[48px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tw-w-[60%]",
                children: isShow && renderImage(columnData)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "tw-flex tw-w-[40%] tw-flex-col tw-gap-[20px]",
                children: [
                    renderTitleAndDescription(columnData),
                    (buttonConfig === null || buttonConfig === void 0 ? void 0 : (ref = buttonConfig[0]) === null || ref === void 0 ? void 0 : ref.isShow) && renderButton(columnData, index)
                ]
            })
        ]
    });
}


/***/ }),

/***/ 94078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TV": function() { return /* binding */ getDescriptionStyle; },
/* harmony export */   "eK": function() { return /* binding */ getDateStyle; },
/* harmony export */   "ij": function() { return /* binding */ getTitleStyles; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var getTitleStyles = function(config, isMobile) {
    var style = {};
    var currFontType = isMobile ? config === null || config === void 0 ? void 0 : config.titleSizeMobile : config === null || config === void 0 ? void 0 : config.titleSizeDesktop;
    switch(currFontType){
        case "extraSmall":
            style.fontSize = "12px";
            style.lineHeight = "1";
            break;
        case "small":
            style.fontSize = "14px";
            style.lineHeight = "1";
            break;
        case "medium":
            style.fontSize = "16px";
            style.lineHeight = "1.2";
            break;
        case "large":
            style.fontSize = "18px";
            style.lineHeight = "1.2";
            break;
        case "extraLarge":
            style.fontSize = "20px";
            style.lineHeight = "1.2";
            break;
        default:
            style.fontSize = "16px";
            style.lineHeight = "1.1";
            break;
    }
    switch(config === null || config === void 0 ? void 0 : config.titleThicness){
        case "thin":
            style.fontWeight = "300";
            break;
        case "regular":
            style.fontWeight = "400";
            break;
        case "medium":
            style.fontWeight = "500";
            break;
        case "bold":
            style.fontWeight = "700";
            break;
        default:
            style.fontWeight = "400";
            break;
    }
    switch(config === null || config === void 0 ? void 0 : config.titleTextCase){
        case "none":
            style.textTransform = "none";
            break;
        case "capitalize":
            style.textTransform = "capitalize";
            break;
        case "uppercase":
            style.textTransform = "uppercase";
            break;
    }
    return {
        style: style
    };
};
var getDescriptionStyle = function(config, isMobile) {
    var style = {};
    var currFontType = isMobile ? config === null || config === void 0 ? void 0 : config.descriptionSizeMobile : config === null || config === void 0 ? void 0 : config.descriptionSizeDesktop;
    switch(currFontType){
        case "extraSmall":
            style.fontSize = "12px";
            style.lineHeight = "1";
            break;
        case "small":
            style.fontSize = "14px";
            style.lineHeight = "1";
            break;
        case "medium":
            style.fontSize = "16px";
            style.lineHeight = "1.2";
            break;
        case "large":
            style.fontSize = "18px";
            style.lineHeight = "1.2";
            break;
        case "extraLarge":
            style.fontSize = "20px";
            style.lineHeight = "1.2";
            break;
        default:
            style.fontSize = "16px";
            style.lineHeight = "1.1";
            break;
    }
    switch(config === null || config === void 0 ? void 0 : config.descriptionThicness){
        case "thin":
            style.fontWeight = "300";
            break;
        case "regular":
            style.fontWeight = "400";
            break;
        case "medium":
            style.fontWeight = "500";
            break;
        case "bold":
            style.fontWeight = "700";
            break;
        default:
            style.fontWeight = "400";
            break;
    }
    switch(config === null || config === void 0 ? void 0 : config.descriptionTextCase){
        case "none":
            style.textTransform = "none";
            break;
        case "capitalize":
            style.textTransform = "capitalize";
            break;
        case "uppercase":
            style.textTransform = "uppercase";
            break;
    }
    return {
        style: style
    };
};
var getDateStyle = function(config, isMobile) {
    var style = {};
    var currFontType = config === null || config === void 0 ? void 0 : config.dateSize;
    switch(currFontType){
        case "extraSmall":
            style.fontSize = "12px";
            style.lineHeight = "1";
            break;
        case "small":
            style.fontSize = "14px";
            style.lineHeight = "1";
            break;
        case "medium":
            style.fontSize = "16px";
            style.lineHeight = "1.2";
            break;
        case "large":
            style.fontSize = "18px";
            style.lineHeight = "1.2";
            break;
        case "extraLarge":
            style.fontSize = "20px";
            style.lineHeight = "1.2";
            break;
        default:
            style.fontSize = "16px";
            style.lineHeight = "1.1";
            break;
    }
    switch(config === null || config === void 0 ? void 0 : config.dateThicness){
        case "thin":
            style.fontWeight = "300";
            break;
        case "regular":
            style.fontWeight = "400";
            break;
        case "medium":
            style.fontWeight = "500";
            break;
        case "bold":
            style.fontWeight = "700";
            break;
        default:
            style.fontWeight = "400";
            break;
    }
    switch(config === null || config === void 0 ? void 0 : config.dateTextCase){
        case "none":
            style.textTransform = "none";
            break;
        case "capitalize":
            style.textTransform = "capitalize";
            break;
        case "uppercase":
            style.textTransform = "uppercase";
            break;
    }
    return {
        style: style
    };
};


/***/ })

}]);